// icons
import Vue from 'vue';
import Light from '@/components/icons/Light.vue';
import Heat from '@/components/icons/Heat.vue';
import ElMeter from '@/components/icons/ElMeter.vue';
import MultiswitchDouble from '@/components/icons/MultiswitchDouble.vue';
import MultiswitchSingle from '@/components/icons/MultiswitchSingle.vue';
import Regulator from '@/components/icons/Regulator.vue';
import SwitchDouble from '@/components/icons/SwitchDouble.vue';
import SwitchSingle from '@/components/icons/SwitchSingle.vue';
import WeatherMeter from '@/components/icons/WeatherMeter.vue';
import SunBlind from '@/components/icons/SunBlind.vue';
import FVEInverter from '@/components/icons/FVEInverter.vue';
import Weather from '@/components/icons/Weather.vue';
import Energy from '@/components/icons/Energy.vue';
import System from '@/components/icons/System.vue';
import Mode from '@/components/icons/Mode.vue';
import CO2Meter from '@/components/icons/CO2Meter.vue';
import WaterTreatment from '@/components/icons/WaterTreatment.vue';
import CoolingDevice from '@/components/icons/CoolingDevice.vue';
import DimmLight from '@/components/icons/DimmLight.vue';
import FVEPowerStation from '@/components/icons/FVEPowerStation.vue';
import GeneralElectricalDevice from '@/components/icons/GeneralElectricalDevice.vue';
import HeatDevice from '@/components/icons/HeatDevice.vue';
import HumidityMeter from '@/components/icons/HumidityMeter.vue';
import Irrigation from '@/components/icons/Irrigation.vue';
import IrrigationCircuit from '@/components/icons/IrrigationCircuit.vue';
import LightDALI from '@/components/icons/LightDALI.vue';
import Pond from '@/components/icons/Pond.vue';
import PressureMeter from '@/components/icons/PressureMeter.vue';
import RGBLight from '@/components/icons/RGBLight.vue';
import SwimmingPool from '@/components/icons/SwimmingPool.vue';
import ThermoHumidityMeter from '@/components/icons/ThermoHumidityMeter.vue';
import Thermometer from '@/components/icons/Thermometer.vue';
import TimeUpdate from '@/components/icons/TimeUpdate.vue';
import UnderfloorHeating from '@/components/icons/UnderfloorHeating.vue';
import UVLamp from '@/components/icons/UVLamp.vue';
import Ventilator from '@/components/icons/Ventilator.vue';
import WaterLevelMeasurement from '@/components/icons/WaterLevelMeasurement.vue';
import WaterMeasuring from '@/components/icons/WaterMeasuring.vue';
import WaterMeter from '@/components/icons/WaterMeter.vue';
import WaterPumping from '@/components/icons/WaterPumping.vue';
import WaterSoftener from '@/components/icons/WaterSoftener.vue';
import WaterSupply from '@/components/icons/WaterSupply.vue';
import AlarmDetector from "@/components/icons/AlarmDetector";
import AlarmOutput from "@/components/icons/AlarmOutput";
import AlarmZone from "@/components/icons/AlarmZone";
import Communication from "@/components/icons/Communication";
import Jablotron from "@/components/icons/Jablotron";
import Security from "@/components/icons/Security";
import Gate from '@/components/icons/Gate';
import GateDevice from '@/components/icons/GateDevice';
import HeatingPumpControl from '@/components/icons/HeatingPumpControl';
import Fireplace from '@/components/icons/Fireplace';
import HeatingTank from '@/components/icons/HeatingTank';
import DoorDevice from '@/components/icons/DoorDevice';
import Door from '@/components/icons/Door';
import Device from '@/components/icons/Device';
import HeatingPump from '@/components/icons/HeatingPump';
import Input from '@/components/icons/Input';
import MixingValve from '@/components/icons/MixingValve';
import Pir from '@/components/icons/Pir';
import RainDetector from '@/components/icons/RainDetector';
import SwimmingPoolCleaner from '@/components/icons/SwimmingPoolCleaner';
import SwimmingPoolFiltration from '@/components/icons/SwimmingPoolFiltration';
import SwimmingPoolJet from '@/components/icons/SwimmingPoolJet';
import TemperatureLight from '@/components/icons/TemperatureLight';
import TouchGlass from '@/components/icons/TouchGlass';
import WaterJetPump from '@/components/icons/WaterJetPump';
import WaterPump from '@/components/icons/WaterPump';
import WeatherStation from '@/components/icons/WeatherStation';

// wrappers
import LightWrapper from '@/components/services/service/icon-wrappers/LightWrapper.vue';
import HeatWrapper from '@/components/services/service/icon-wrappers/HeatWrapper.vue';
import HeatDeviceWrapper from '@/components/services/service/icon-wrappers/HeatDeviceWrapper.vue';
import UnderfloorHeatingWrapper from '@/components/services/service/icon-wrappers/UnderfloorHeatingWrapper.vue';
import CoolingDeviceWrapper from '@/components/services/service/icon-wrappers/CoolingDeviceWrapper.vue';


export default function loadServiceIcons() {
  // icons
  Vue.component('Light', Light);
  Vue.component('Heat', Heat);
  Vue.component('ElMeter', ElMeter);
  Vue.component('MultiswitchDouble', MultiswitchDouble);
  Vue.component('MultiswitchSingle', MultiswitchSingle);
  Vue.component('SwitchDouble', SwitchDouble);
  Vue.component('SwitchSingle', SwitchSingle);
  Vue.component('WeatherMeter', WeatherMeter);
  Vue.component('Regulator', Regulator);
  Vue.component('SunBlind', SunBlind);
  Vue.component('FVEInverter', FVEInverter);
  Vue.component('Mode', Mode);
  Vue.component('System', System);
  Vue.component('Energy', Energy);
  Vue.component('Weather', Weather);
  Vue.component('CO2Meter', CO2Meter);
  Vue.component('CoolingDevice', CoolingDevice);
  Vue.component('DimmLight', DimmLight);
  Vue.component('FVEPowerStation', FVEPowerStation);
  Vue.component('GeneralElectricalDevice', GeneralElectricalDevice);
  Vue.component('HeatDevice', HeatDevice);
  Vue.component('HumidityMeter', HumidityMeter);
  Vue.component('Irrigation', Irrigation);
  Vue.component('IrrigationCircuit', IrrigationCircuit);
  Vue.component('LightDALI', LightDALI);
  Vue.component('Pond', Pond);
  Vue.component('PressureMeter', PressureMeter);
  Vue.component('RGBLight', RGBLight);
  Vue.component('SwimmingPool', SwimmingPool);
  Vue.component('ThermoHumidityMeter', ThermoHumidityMeter);
  Vue.component('Thermometer', Thermometer);
  Vue.component('TimeUpdate', TimeUpdate);
  Vue.component('UnderfloorHeating', UnderfloorHeating);
  Vue.component('UVLamp', UVLamp);
  Vue.component('Ventilator', Ventilator);
  Vue.component('WaterLevelMeasurement', WaterLevelMeasurement);
  Vue.component('WaterMeasuring', WaterMeasuring);
  Vue.component('WaterMeter', WaterMeter);
  Vue.component('WaterPumping', WaterPumping);
  Vue.component('WaterSoftener', WaterSoftener);
  Vue.component('WaterSupply', WaterSupply);
  Vue.component('WaterTreatment', WaterTreatment);
  Vue.component('AlarmDetector', AlarmDetector);
  Vue.component('AlarmOutput', AlarmOutput);
  Vue.component('AlarmZone', AlarmZone);
  Vue.component('Communication', Communication);
  Vue.component('Jablotron', Jablotron);
  Vue.component('Security', Security);
  Vue.component('Gate', Gate);
  Vue.component('GateDevice', GateDevice);
  Vue.component('HeatingPumpControl', HeatingPumpControl);
  Vue.component('Fireplace', Fireplace);
  Vue.component('HeatingTank', HeatingTank);
  Vue.component('DoorDevice', DoorDevice);
  Vue.component('Door', Door);
  Vue.component('Device', Device);
  Vue.component('HeatingPump', HeatingPump);
  Vue.component('Input', Input);
  Vue.component('MixingValve', MixingValve);
  Vue.component('Pir', Pir);
  Vue.component('RainDetector', RainDetector);
  Vue.component('SwimmingPoolCleaner', SwimmingPoolCleaner);
  Vue.component('SwimmingPoolFiltration', SwimmingPoolFiltration);
  Vue.component('SwimmingPoolJet', SwimmingPoolJet);
  Vue.component('TemperatureLight', TemperatureLight);
  Vue.component('TouchGlass', TouchGlass);
  Vue.component('WaterJetPump', WaterJetPump);
  Vue.component('WaterPump', WaterPump);
  Vue.component('WeatherStation', WeatherStation);
  // wrappers
  Vue.component('LightWrapper', LightWrapper);
  Vue.component('HeatWrapper', HeatWrapper);
  Vue.component('CoolingDeviceWrapper', CoolingDeviceWrapper);
  Vue.component('UnderfloorHeatingWrapper', UnderfloorHeatingWrapper);
  Vue.component('HeatDeviceWrapper', HeatDeviceWrapper);
}
